module.exports = __webpack_public_path__ + "static/media/logo.3f5e6ef1.png";